<template>
  <svg
    :class="computedClass"
    :width="size"
    :height="size"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.48043 10.2374V11.1527C3.48043 11.7312 3.94674 12.1986 4.52391 12.1986M1.86304 9.87133C1.00217 9.34834 0.5 8.70767 0.5 8.01798V3.71966M0.5 3.71966C0.558696 4.38974 0.930434 4.98791 1.50761 5.33112M0.5 3.71966C0.558696 4.38647 0.933694 4.98791 1.50761 5.33112M0.5 3.71966C0.5 1.93822 3.8587 0.5 8 0.5C12.1413 0.5 15.5 1.93822 15.5 3.71966M1.50761 5.33112C2.80217 6.29865 5.22174 6.94258 8 6.94258C10.7783 6.94258 13.2011 6.29865 14.4924 5.33112M1.50761 5.33112C2.79891 4.36359 5.22174 3.71966 8 3.71966C10.7783 3.71966 13.1978 4.36359 14.4924 5.33112M14.4924 5.33112C15.0663 4.98791 15.4413 4.38647 15.5 3.71966M15.5 3.71966V8.01471C15.5 8.70441 14.9946 9.34507 14.137 9.86806M1.86304 8.371C1.86304 8.24679 1.92825 8.12912 2.0326 8.06047C2.13695 7.99183 2.27065 7.98202 2.38478 8.03105C4.16848 8.7469 6.07935 9.09665 8 9.05416C9.92065 9.09338 11.8315 8.7469 13.612 8.03105C13.7261 7.98202 13.8598 7.99183 13.9641 8.06047C14.0685 8.12912 14.1337 8.24679 14.1337 8.371V11.8685C14.1337 14.4736 8.78587 14.3004 8.2413 13.4048C8.19239 13.3165 8.09782 13.2642 7.99674 13.2642C7.89565 13.2642 7.80108 13.3198 7.75217 13.4048C7.20761 14.3004 1.85978 14.4736 1.85978 11.8685V8.371"
      :stroke="color"
      stroke-miterlimit="10"
    />
  </svg>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  size?: number | string;
  color?: string;
  class?: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: 24,
  color: "currentColor",
  class: "",
});

const computedClass = computed(() => props.class);
</script>
